<span class="m-auto text-blue portrait-container" *ngIf="!image"> {{ initials }} </span>

<img class="profile-img" *ngIf="image" src="{{image}}"/>
<!-- <ngx-avatar name="John Doe" size="50"></ngx-avatar> -->
<input
  type="file"
  name=""
  id="society"
  style="display: none"
  (change)="imageChange($event)"
  accept="{{ accept }}"
  #hiddenInput
/>
<div class="img-container cursor">
  <a (click)="hiddenInput.click()">
  <div class="circle">
    <img src="assets/svg/Edit.svg" alt="" style="width: 80%" />
  </div>
  </a>
</div>
